module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADzSURBVEhL7ZLBDYJAEEU5mNiBJp61CQtQyvBkTzZisAAieNQSjBVw0Qv6Z30hEDdCXI0HfckPzMzfv7uB6M8PUpZlLOVSwTNmFA7h5bWG1WKOJQwF7chtoH6GJQwFFWQ2sD6WMBSUk9ngnTeYS75vMMPiRfO+tEJ92n5ksA+dSfYXbaW28JGUch47UGo9xmEoaCqdyK6wns2wvYZylgo53yMfYbbE7hb0pIUGCSe48Eysb3OsDtWdcGaFTKQDPS+a76WxWyBot2LhQ+lI/RTzSQPfBm5XQVlhG2x474T8a28QUFZ0vmodbxBQVnx+gz9fJopuXqX4LAdxIQ0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-caretaker/light/24.png
// module id = 1914
// module chunks = 2